/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { render } from '../lib';
import { VmControls } from '@vime/core';
import { define } from '../lib';
define('vm-controls', VmControls);
export default Vue.extend({
    props: {
        hidden: {},
        fullWidth: {},
        fullHeight: {},
        direction: {},
        align: {},
        justify: {},
        pin: {},
        activeDuration: {},
        waitForPlaybackStart: {},
        hideWhenPaused: {},
        hideOnMouseLeave: {},
        isAudioView: {},
        isSettingsActive: {},
        playbackReady: {},
        isControlsActive: {},
        paused: {},
        playbackStarted: {},
    },
    methods: {},
    render: render('vm-controls', []),
});
//# sourceMappingURL=Controls.js.map